import React from 'react';
import { Typography } from '@mui/material';

interface SectionTitleProps {
  title: string;
  isCompact: boolean;
}

export const SectionTitle = ({ title, isCompact }: SectionTitleProps) => {
  return (
    <Typography
      sx={{
        marginTop: isCompact ? 2 : 6,
        marginBottom: isCompact ? 2 : 4,
        fontWeight: 600,
        fontSize: 18,
      }}
    >
      {title}
    </Typography>
  );
};
